import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Avatar, Badge, Box, CollapseCard, FlexBox, Tooltip, } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useMemo } from 'react';
import { ConversationCustomFieldsForm } from 'components/conversation/conversationCustomFieldsForm';
import { getEmptyCustomFields, useCustomFields } from 'utils/customFields';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useCurrentUserInAcw } from 'utils/user';
import styles from './conversationCustomFieldsCard.module.scss';
export const ConversationCustomFieldsCard = ({ csid, isMinimized, isOpen, onToggle, }) => {
    var _a;
    const { customFields, rawResponse } = useCustomFields({
        entityId: 'conversation',
        entityInstanceId: csid,
    });
    const { requiredCustomAttribute } = useFeatureFlag([
        'required-custom-attribute',
    ]);
    const isCurrentUserInAcw = useCurrentUserInAcw({ csid });
    const missingRequiredAttributesCount = getEmptyCustomFields({
        customFields,
        onlyRequired: true,
    }).length;
    const badge = useMemo(() => {
        if (!requiredCustomAttribute) {
            return null;
        }
        if (!missingRequiredAttributesCount) {
            return null;
        }
        return (_jsx(Tooltip, Object.assign({ dark: true, content: _jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "100" }, { children: [_jsxs(Box, { children: [missingRequiredAttributesCount, " required", ' ', missingRequiredAttributesCount > 1
                                ? 'attributes (*) are'
                                : 'attribute (*) is', ' ', "missing value."] }), isCurrentUserInAcw && (_jsx(Box, { children: "Wrap-up time will not end until all required arributes are filled in." }))] })) }, { children: _jsxs(Badge, Object.assign({ className: classnames({ [styles.badge]: !isMinimized }), variant: "warning", size: "small" }, { children: [missingRequiredAttributesCount, " *"] })) })));
    }, [
        isCurrentUserInAcw,
        isMinimized,
        missingRequiredAttributesCount,
        requiredCustomAttribute,
    ]);
    const inputIcon = _jsx(Avatar, { icon: "input" });
    if (!customFields.length || !((_a = rawResponse.attributes) === null || _a === void 0 ? void 0 : _a.isSuccess)) {
        return null;
    }
    if (isMinimized) {
        return (_jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "100" }, { children: [_jsx("div", Object.assign({ className: "icon-holder" }, { children: inputIcon })), badge] })));
    }
    return (_jsxs(CollapseCard, Object.assign({ isOpen: isOpen, onToggle: onToggle }, { children: [_jsxs(CollapseCard.Header, Object.assign({ avatar: inputIcon }, { children: ["Conversation attributes", badge] })), _jsx(CollapseCard.Content, { children: _jsx(ConversationCustomFieldsForm, { customFields: customFields, csid: csid }) })] })));
};
